import * as React from "react";
const SvgErrorGray = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M7.99992 1.3335C4.31992 1.3335 1.33325 4.32016 1.33325 8.00016C1.33325 11.6802 4.31992 14.6668 7.99992 14.6668C11.6799 14.6668 14.6666 11.6802 14.6666 8.00016C14.6666 4.32016 11.6799 1.3335 7.99992 1.3335Z",
	fill: "#969FA8"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M8.66659 11.3333H7.33325V10H8.66659V11.3333Z",
	fill: "white"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M8.66659 8.6665H7.33325V4.6665H8.66659V8.6665Z",
	fill: "white"
}));
export default SvgErrorGray;
